import ContentsTypes from "@shared/enums/contentsTypes";
export const createColorImageBlock = (verticalSize, horizontalSize, maxVerticalSize, imageName, backgroundColor, iconName, iconColor) => ({
    key: "items",
    type: "COLOR_IMAGE_BLOCK",
    value: "",
    children: [
        {
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
            children: [
                {
                    key: "file",
                    type: ContentsTypes.FILE_IMAGE,
                    value: JSON.stringify({
                        id: "",
                        name: imageName,
                        mimeType: "image/webp",
                        publicUrl: imageName?.startsWith("http")
                            ? imageName
                            : `/api/medias/${""}`,
                        url: imageName?.startsWith("http")
                            ? imageName
                            : `/api/medias/${""}`,
                        alt: "image",
                        title: "image",
                        position_ajustement: "cover",
                        filters: {
                            label: "Filtres",
                            type: "IMAGE_FILTERS",
                            children: [
                                {
                                    type: "CHECKBOX",
                                    label: "Ajouter des filtres",
                                    key: "activated",
                                    value: "true",
                                    children: [],
                                },
                                {
                                    label: "Opacité",
                                    type: "SLIDER",
                                    value: "0.8",
                                    min: "0",
                                    max: "1",
                                    step: "0.05",
                                    key: "opacity",
                                    children: [],
                                },
                                {
                                    label: "Flou",
                                    type: "SLIDER",
                                    value: "0",
                                    min: "0",
                                    max: "5",
                                    step: "0.25",
                                    key: "blur",
                                    children: [],
                                },
                                {
                                    label: "Échelle de gris",
                                    type: "SLIDER",
                                    value: "0",
                                    min: "0",
                                    max: "1",
                                    step: "0.05",
                                    key: "grayscale",
                                    children: [],
                                },
                                {
                                    label: "Luminosité",
                                    type: "SLIDER",
                                    value: "1",
                                    min: "0",
                                    max: "3",
                                    step: "0.1",
                                    key: "brightness",
                                    children: [],
                                },
                                {
                                    label: "Saturation",
                                    type: "SLIDER",
                                    value: "1",
                                    min: "0",
                                    max: "3",
                                    step: "0.2",
                                    key: "saturate",
                                    children: [],
                                },
                                {
                                    label: "Sépia",
                                    type: "SLIDER",
                                    value: "0",
                                    min: "0",
                                    max: "1",
                                    step: "0.05",
                                    key: "sepia",
                                    children: [],
                                },
                            ],
                            key: "filters",
                            value: "",
                        },
                    }),
                },
                { key: "alt", type: ContentsTypes.INPUT, value: "image" },
                { key: "title", type: ContentsTypes.INPUT, value: "image" },
                {
                    key: "position_verticale",
                    type: ContentsTypes.SELECT,
                    value: "top",
                },
                {
                    key: "position_horizontale",
                    type: ContentsTypes.SELECT,
                    value: "center",
                },
                {
                    key: "position_ajustement",
                    type: ContentsTypes.SELECT,
                    value: "cover",
                },
                {
                    key: "filters",
                    type: "IMAGE_FILTERS",
                    value: "",
                    children: [
                        { key: "activated", type: "CHECKBOX", value: "true" },
                        { key: "opacity", type: "SLIDER", value: "0.8" },
                        { key: "blur", type: "SLIDER", value: "0" },
                        { key: "grayscale", type: "SLIDER", value: "0" },
                        { key: "brightness", type: "SLIDER", value: "1" },
                        { key: "saturate", type: "SLIDER", value: "1" },
                        { key: "sepia", type: "SLIDER", value: "0" },
                    ],
                },
            ],
        },
        {
            key: "backgroundColor",
            type: ContentsTypes.COLOR,
            value: backgroundColor,
        },
        {
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                { key: "icon", type: ContentsTypes.INPUT, value: iconName },
                { key: "type", type: ContentsTypes.SELECT, value: "custom" },
                { key: "color", type: ContentsTypes.COLOR, value: iconColor },
                { key: "background", type: ContentsTypes.COLOR, value: "" },
            ],
        },
        { key: "verticalSize", type: "INPUT_NUMBER", value: verticalSize },
        { key: "horizontalSize", type: "INPUT_NUMBER", value: horizontalSize },
        { key: "maxVerticalSize", type: "INPUT_NUMBER", value: maxVerticalSize },
    ],
});
